import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-case-study-detail2',
  templateUrl: './case-study-detail2.component.html',
  styleUrls: ['./case-study-detail2.component.scss'],
})
export class CaseStudyDetail2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {
    window.scroll(0, 0)
  }
}
